export default __webpack_public_path__ + "img/homepage-desktop-halloween.ec48594a.svg";